import CreateBtn from "@components/CreateButton";
import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import Table from "@components/Table";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import useListColumns from "@hooks/Media/useListColumns";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import useListItems from "@hooks/Shared/useListItems";
import listMapper from "@mappers/Modules/media/ListMedia.mapper";
import deleteMedia from "@services/Media/deleteMedia";
import getAwards from "@services/Media/getMediaList";
import { ReactElement, useEffect, useState } from "react";
import { Container } from "reactstrap";

const ListItems = (): ReactElement => {
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    getAwards,
    listMapper,
    isDeletingItem
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`Media | Delete confirmation`}
        body={`Are you sure you want to remove the item:  "${basicData?.description}" ?`}
        handleConfirm={() => {
          handleDelete(deleteMedia);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />
      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
